import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import Dialog from "components/ui/atoms/Dialog";
import Highlight from "components/ui/atoms/Highlight";

const WithConfirmationButton = ({
  children,
  confirmationMessage,
  Component,
  ...props
}) => {
  const theme = useTheme();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const handleOpenConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const FinalComponent = Component || Button;

  return (
    <>
      <Dialog
        open={openConfirmation}
        onClose={handleOpenConfirmation}
        title={
          <Highlight color={theme.palette_custom.yellow}>
            {confirmationMessage}
          </Highlight>
        }
        actions={
          <>
            <Button
              {...props}
              variant="contained"
              onClick={async () => {
                try {
                  await props.onClick();
                } finally {
                  handleOpenConfirmation();
                }
              }}
              endIcon={props?.endIcon}
            >
              Confirm
            </Button>
            <Button variant="outlined" onClick={handleOpenConfirmation}>
              Cancel
            </Button>
          </>
        }
      ></Dialog>
      <FinalComponent {...props} onClick={handleOpenConfirmation}>
        {children}
      </FinalComponent>
    </>
  );
};

export default WithConfirmationButton;
